import elementStateToggle from "./elementStateToggle";

const accordion = {
    init() {
        elementStateToggle.init({
            triggerElementSelector: '.js-accordion-header',
            toggleActiveElement: true,
            removeAllActiveClasses: false,
        });
    }
}

export default accordion;